<template>
  <div id="app">
    <Menu/>
    <Logo/>
    <router-view/>
    <Cdnrecords/>
    <Footer/>
  </div>
</template>

<script>

import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import Logo from '@/components/Logo'
import Cdnrecords from '@/components/Cdnrecords'

export default {
  name: 'App',
  components: {
    Menu,
    Footer,
    Logo,
    Cdnrecords,
  }
}
</script>

<style>
html, body{
  margin: 0px;
  padding: 0px;
}

html, body, div, a{
  font-family: 'Oswald', sans-serif;
  font-size: 2.9vw;
}

body{
  background-color: black;
  background-image: url('assets/BG.png');
  background-position: center 0px;
  background-attachment: fixed;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover; 
}

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 97vh;
}

.containerShaded{
  border-radius: 5px;
  padding: 1vh;
  margin: 0 5vh;
  background: rgba(0, 0, 0, .8);
  color: #eeeeee;
  font-size: 2.5vw;
}


@media only screen and (max-width: 450px) {
  html, body, div, a{
    font-family: 'Oswald', sans-serif;
    font-size: 6vw;
  }

  .containerShaded{
    border-radius: 0px;
    padding: 1vh;
    margin: 0;
    background: rgba(0, 0, 0, .8);
    color: #eeeeee;
    font-size: 4.0vw;
  }
}


</style>


// WEBPACK FOOTER //
// src/App.vue